import { CanDeactivateFn } from '@angular/router';
import { TestlaufRunnerComponent } from './testlauf-runner.component';

export const canDeactivateTestlaufRunner: CanDeactivateFn<TestlaufRunnerComponent> = (component) => {
  return component.confirmDeactivate();
};
